<template>
  <div>
    <!-- IOS/安卓 -->
    <div v-if="isPhone" style="position: relative">
      <div
          class="form-label-pwd"
      >
        <div class="pwd">
          <input
              v-for="(item, index) in 6"
              :id="'inputR'+index"
              :key="index"
              :value="index === 0 ? (showValues[index] || '') : ' ' + (showValues[index] || '') + ' '"
              class="pwd-item-input"
              :class="index === showValues.length ? 'active' : ''"
              type="text"
              inputmode="numeric"
              :autocomplete="index === 0 ? 'one-time-code' : 'new-password'"
              v-on:click.stop="inputRClick"
              v-on:touchstart="inputRTouchstart"
              v-on:touchmove="inputRTouchmove"
              v-on:touchend="inputRTouchend"
              v-on:touchcancel="inputRTouchend"
              v-on:select.prevent="inputRCursorChange"
              v-on:copy.prevent
              v-on:cut.prevent
              v-on:input="inputRInput"
              v-on:keyup.delete.stop.prevent="inputRDel"
          />
        </div>
      </div>
    </div>
    <!-- Win -->
    <div v-else style="position: relative">
      <div>
        <form
            id="form-label-pwd"
            class="form-label-pwd"
            onsubmit="return false"
            contenteditable
            v-on:contextmenu.stop="inputFocus()"
            v-on:copy.prevent
            v-on:cut.prevent
            v-on:paste.capture="handleTouchPaste"
            v-on:touchstart="handleTouchstart"
        >
          <ul class="pwd">
            <li v-for="(item, index) in 6" :key="index" class="pwd-item" :class="index === showValues.length?'active':''">
              <span>{{ showValues[index] }}</span>
            </li>
          </ul>
        </form>
      </div>
    </div>
    <input
        id="inputH"
        ref="inputRef"
        v-model="inputValue"
        class="hidden-input"
        type="text"
        inputmode="numeric"
        autocomplete="new-password"
        pattern="[0-9]*"
        v-on:input="(event) => inputChange(event)"
        v-on:select.prevent="cursorChange"
        v-on:keydown="cursorChange"
        v-on:copy.prevent
        v-on:cut.prevent
    />
  </div>
</template>

<script>
export default {
  name: "SmsInput",
  model: {
    prop: "value",
    event: "update_model"
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      inputValue: "",
      isLongPress: false
    };
  },
  computed: {
    showValues() {
      return this.inputValue.split("");
    },
    isPhone() {
      const UA = window.navigator.userAgent,
          IsAndroid =
              /Android|HTC/i.test(UA) ||
              !!(window.navigator["platform"] + "").match(/Linux/i),
          IsIPad = !IsAndroid && /iPad/i.test(UA),
          IsIPhone = !IsAndroid && /iPod|iPhone/i.test(UA);
      return IsIPhone || IsIPad || IsAndroid;
    },
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent);
    }
  },
  watch: {
    value: {
      handler(val) {
        this.inputChange(val.password ? val.password.join("") : "", false);
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.isPhone) {
      if (this.isIOS) {
        document.addEventListener("visibilitychange", this.smsHandlerIOS);
      } else {
        if ("OTPCredential" in window) {
          window.addEventListener("DOMContentLoaded", this.smsHandler);
        }
      }
    }
  },
  mounted() {
    this.init();
  },
  activated() {
    this.inputFocus(true);
  },
  beforeDestroy() {
    if (this.isPhone) {
      if (this.isIOS) {
        document.removeEventListener("visibilitychange", this.smsHandlerIOS);
      } else {
        if ("OTPCredential" in window) {
          window.removeEventListener("DOMContentLoaded", this.smsHandler);
        }
      }
    }
  },
  methods: {
    init() {
      this.inputValue = "";
      this.inputFocus(true);
    },
    // input
    smsHandlerIOS() {
      if (!document.hidden) {
        this.inputFocus();
      } else {
        document.getElementById("inputR0").blur();
      }
    },
    smsHandler() {
      // const input = document.querySelector('input[autocomplete="one-time-code"]');
      const input = document.getElementById("inputH");
      if (!input) return;
      const ac = new AbortController();
      // 用户可以自己输入验证码并且提交，使用 AbortController 终止 Web OTP API 的自动填充
      // AbortController 还可以终止 fetch 的请求
      // 监听终止事件 ac.signal.addEventListener('abort', function(){});
      const form = input.closest("form");
      if (form) {
        form.addEventListener("submit", () => {
          ac.abort(); // 终止 Web OTP API 的自动填充
        });
      }
      navigator.credentials.get({
        otp: { transport: ["sms"] },
        signal: ac.signal
      }).then(otp => {
        // input.value = otp.code;
        this.inputChange(document.getElementById("inputH").value + otp.code);
        if (form) form.submit();
      }).catch(err => {
        console.log(err);
      });
    },
    // input
    inputFocus(refresh = false) {
      this.isLongPress = false;
      let el = null;
      this.$nextTick(() => {
        if (this.isPhone) {
          if (this.showValues.length < 6) {
            el = document.getElementById("inputR" + this.showValues.length);
          }
        } else {
          el = this.$refs.inputRef;
        }
        if (el) {
          if (refresh) {
            this.$refs.inputRef.focus();
            setTimeout(() => {
              el.focus();
              this.adjHeight();
            }, 0);
          } else {
            el.focus();
            this.adjHeight();
          }
        }
      });
    },
    adjHeight() {
      if (!this.isPhone) return;
      const isIOS = window.visualViewport;
      const curHeight = isIOS ? window.visualViewport.height : window.innerHeight;
      setTimeout(() => {
        const nowHeight = isIOS ? window.visualViewport.height : window.innerHeight;
        const diff = curHeight - nowHeight;
        if (Math.abs(diff) > 150) {
          if (isIOS)
            window.scrollBy({
              top: diff,
              behavior: "smooth"
            });
          else
            window.scrollTo({
              top: diff,
              behavior: "smooth"
            });
        }
      }, isIOS ? 400 : 300);
    },
    cursorChange({ target }) {
      const index = this.inputValue.length;
      target.setSelectionRange(index, index);
    },
    inputChange(event, update = true) {
      let val;
      if (typeof event === "string")
        val = event;
      else
        val = document.getElementById("inputH").value;
      this.inputValue = val.replace(/[^0-9]/g, "").substr(0, 6);
      if (update) {
        const obj = {
          curIndex: this.inputValue.length ? this.inputValue.length - 1 : -1,
          password: this.showValues
        };
        this.$emit("update_model", obj);
        this.$emit("pwd-get",obj);
      }
      this.inputFocus();
    },
    // 长按-Win
    handleTouchstart() {
      this.inputFocus();
      return false;
    },
    handleTouchPaste() {
      this.inputFocus();
      // 防止个别机型无法粘贴到一个框
      this.$nextTick(() => {
        const el = document.getElementById("form-label-pwd");
        const val = el.value;
        if (val.length > 0) {
          this.inputChange(document.getElementById("inputH").value + val);
        }
      });
      return false;
    },
    // 长按-移动
    inputRInput(event) {
      const id = event.target.id;
      const el = document.getElementById(id);
      if (el.value === " ") {
        // 各别安卓机不能监听keyup.delete
        this.inputRDel();
        return;
      }
      const oriVal = el.value.replace(/[^0-9]/g, "");
      if (!oriVal || this.inputValue.length >= 6) return;
      this.inputFocus();
      this.$nextTick(() => {
        if (oriVal.length !== 0) {
          // 选中+输入/粘贴
          const text = document.getElementById("inputH").value + oriVal;
          this.inputChange(text);
        }
      });
    },
    inputRDel() {
      this.inputChange(this.inputValue.slice(0, -1));
      return false;
    },
    inputRClick(event) {
      const id = event.target.id;
      this.inputFocus(id !== "inputR" + this.showValues.length);
    },
    inputRTouchstart(event) {
      const id = event.target.id;
      const el = document.getElementById(id);
      if (id === "inputR" + this.showValues.length && !this.isLongPress) {
        setTimeout(() => {
          this.isLongPress = true;
          const len = el.value.length;
          event.target.setSelectionRange(len, len);
        }, 500); // 长按阈值
      }
    },
    inputRTouchmove(event) {
      // 防止界面抖动
      if (this.isLongPress) {
        event.preventDefault();
      }
    },
    inputRTouchend(event) {
      const id = event.target.id;
      this.inputFocus(id !== "inputR" + this.showValues.length);
    },
    inputRCursorChange({ target }) {
      const id = target.id;
      const el = document.getElementById(id);
      const len = el.value.length;
      target.setSelectionRange(len, len);
    }
  }
};
</script>

<style lang="scss" scoped>
.form-label-pwd {
  outline: none !important;
  caret-color: transparent;
  position: relative;
  .pwd {
    display: flex;
    padding: 0 3.5rem;
    justify-content: space-between;
    .pwd-item-input {
      background: #FFF;
      border: 0.1rem solid #ebebeb;
      border-radius: 0.3rem;
      font-size: 2rem;
      width: 4rem;
      height: 4rem;
      text-align: center;
      -webkit-user-select: text;
      user-select: text;
      -webkit-touch-callout: default;
      outline: none !important;
      caret-color: transparent !important;

      &.active {
        border: 1px solid rgba(225, 96, 58, 0.7);
      }
    }
    .pwd-item {
      width: 4rem;
      height: 4rem;
      font-size: 2rem;
      background: #FFF;
      border: 0.1rem solid #ebebeb;
      border-radius: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        user-select: none;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
      }
      i {
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 1.5rem;
        background-color: #333;
      }
    }
  }
  .mint-field .mint-cell-wrapper{border:none;padding: 0;}
}
.hidden-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
